import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "thesisSupervision/";

// 论文 - 列表
export const thesisSupervisionPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/thesisSupervision.js